import i from "react";
import { ModalLinks as m } from "../../../features/common/components/ModalLinks/ModalLinks.js";
import { useWindowSize as c } from "../../../features/dom/hooks/useWindowSize.js";
import { convertShopLegalToModalLinks as f } from "../../../features/landing/utils.js";
import u from "./shared-landing.module.scss.js";
import g from "../ShopLanding/hooks/customization/useCustomization.js";
function b(l) {
  var n, s;
  const {
    isDesktop: a
  } = c(), { configuration: e } = g();
  if (!a || e === void 0)
    return null;
  const { design: o, children: d } = l, t = o.general.text, r = o.general.background;
  return /* @__PURE__ */ i.createElement(
    "div",
    {
      className: u.footerArea,
      "data-testid": "shared-landing-footer",
      style: {
        backgroundColor: r,
        color: t
      }
    },
    /* @__PURE__ */ i.createElement(
      m,
      {
        links: f((s = (n = e == null ? void 0 : e.shop) == null ? void 0 : n.settings) == null ? void 0 : s.legal),
        design: {
          color: t,
          backgroundColor: r
        }
      }
    ),
    d
  );
}
export {
  b as SharedLandingFooter
};
//# sourceMappingURL=SharedLandingFooter.js.map
